import script from "./WageLedgerPayDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageLedgerPayDate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__